import project from "../project";

// libs
import semver from 'semver'


export default async function checkPackageVersion() {
  const url = `https://registry.npmjs.org/${project.package.name}`

  const v = await new Promise((resolve, reject) => {

    fetch(url)
      .then(res => res.json())
      .then(res => {
        try {
          const latest = res['dist-tags'].latest
          const current = project.package.version
          const needUpdate = semver.gt(latest, current)
          resolve({
            latest,
            current,
            needUpdate,
          })

        } catch (err) {
          console.error(`Can't parse npm data`)
          resolve(null)
        }
      })
      .catch((err) => {
        console.error(`Can't check package version`)
        reject(err)
      });
  });

  return v

}